import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { UpdatesListPage } from "@/pages/dashboard/updates/list";

export const Route = createFileRoute("/_main/dashboard/updates/")({
  component: () => (
    <RequirePermission action="updates.read">
      <UpdatesListPage />
    </RequirePermission>
  ),
});
